import React, { useState } from 'react';
import '../../styles/TagTextField.css';

const TagTextField = (props: any) => {
  const [inputValue, setInputValue] = useState('');

  const addTag = (e: any) => {
    if ((e.key === 'Enter' || e.key === 'Tab') && inputValue) {
      if(props.config!.enableMultiPropertyConfig){
        props.update({ ...props.config!, propertyIds: [...props.config!.propertyIds, inputValue]})
      }else{
        props.update({ ...props.config!, propertyId: inputValue})
      }
      
      setInputValue('');
      e.preventDefault();
    }
  };

  const addTagOnBlur = () => {
    if (inputValue) {
      if(props.config!.enableMultiPropertyConfig){
        props.update({ ...props.config!, propertyIds: [...props.config!.propertyIds, inputValue]})
      }else{
        props.update({ ...props.config!, propertyId: inputValue})
      }
      setInputValue('');
    }
  };

  const removeTag = (indexToRemove: number) => {
    // setTags(tags.filter((_, index) => index !== indexToRemove));
    if(props.config!.enableMultiPropertyConfig){
      const propertyIds = props.config!.propertyIds.filter((_: any, index: number) => index !== indexToRemove);
      props.update({ ...props.config!, propertyIds: propertyIds})

    }else{
      props.update({ ...props.config!, propertyId: ''})
    }
  };

  return (
    <div className="tag-input-container">
      <div className="tags-container">
        {(props.config!.enableMultiPropertyConfig? [...props.config!.propertyIds]: props.config!.propertyId!==''?[props.config!.propertyId]:[]).map((tag, index) => (
          <div key={index} className="tag">
            {tag}
            <span className="tag-close" onClick={() => removeTag(index)}>
              &times;
            </span>
          </div>
        ))}
      </div>
      <input
        type="text"
        value={inputValue}
        onChange={(e) => {
          if (!(!props.config!.enableMultiPropertyConfig && props.config!.propertyId!=='')) {
            setInputValue(e.target.value);
          }
        }}
        onKeyDown={addTag}
        onBlur={addTagOnBlur}
        placeholder={props.multi? "Type and press Enter to add Property Ids":"Type and press Enter to add Property Id"}
      />
    </div>
  );
};

export default TagTextField;



// WEBPACK FOOTER //
// ./src/components/common/TagTextField.tsx